import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';
import CLPViewState from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
import setSelectedCLPLabel from '../../actions/clp/setSelectedCLPLabel';
import CLPDowngradeModal from '../../components/CLPDowngradeModal';
import { showModal } from 'owa-modal/lib/showModal';
import setJustificationSent from '../../actions/clp/setJustificationSent';
import { logDowngradeJustification, logCLPLabelChange } from './logCLPDatapoints';
import constructCLPAuditAction from './constructCLPAuditAction';
import addAuditActionToViewState from '../../actions/clp/addAuditActionToViewState';
import {
    CLPAuditLogType,
    CLPAuditOperation,
    CLPAuditOperationTrigger,
    CLPAuditSensitivityChange,
} from 'owa-mail-protection-types/lib/schema/clp/CLPAuditAction';

export default function showJustificationModal(
    label: CLPLabel,
    infoBarViewState: InfoBarHostViewState,
    clpViewState: CLPViewState,
    isReplyOrForward: boolean,
    targetWindow: Window
): Promise<boolean> {
    const { originalCLPLabel } = clpViewState;
    const showIfReplyOrForward =
        isReplyOrForward &&
        originalCLPLabel &&
        (!label.parentId || label.parentId != originalCLPLabel.parentId) &&
        label.settingOrder < originalCLPLabel.settingOrder &&
        !clpViewState.justificationSent;
    const showIfCompose =
        !isReplyOrForward &&
        clpViewState.selectedCLPLabel &&
        (!label.parentId || label.parentId != clpViewState.selectedCLPLabel.parentId) &&
        label.settingOrder < clpViewState.selectedCLPLabel.settingOrder;
    // Add audit action removing label
    if (clpViewState.selectedCLPLabel && label.id == clpViewState.selectedCLPLabel.id) {
        addAuditActionToViewState(
            clpViewState,
            constructCLPAuditAction(
                null /*current label*/,
                CLPAuditLogType.LabelAction,
                CLPAuditOperation.LabelRemoved,
                CLPAuditOperationTrigger.Manual,
                CLPAuditSensitivityChange.Downgraded,
                clpViewState.selectedCLPLabel
            )
        );
    }

    if (label.shouldShowDowngradeDialog && (showIfReplyOrForward || showIfCompose)) {
        let [showModalPromise] = showModal(CLPDowngradeModal, targetWindow);

        return showModalPromise.then(
            ({
                success,
                downgradeJustification,
            }: {
                success: boolean;
                downgradeJustification: string;
            }) => {
                if (success && downgradeJustification) {
                    setJustificationSent(clpViewState, true);
                    logDowngradeJustification(clpViewState, downgradeJustification);
                    logCLPLabelChange(clpViewState.selectedCLPLabel, label);

                    //Add audit action for downgrade
                    addAuditActionToViewState(
                        clpViewState,
                        constructCLPAuditAction(
                            label,
                            CLPAuditLogType.LabelAction,
                            CLPAuditOperation.LabelApplied,
                            CLPAuditOperationTrigger.Manual,
                            CLPAuditSensitivityChange.Downgraded,
                            clpViewState.selectedCLPLabel,
                            downgradeJustification
                        )
                    );
                    setSelectedCLPLabel(label, infoBarViewState, clpViewState);
                    //label changed resolve with true
                    return Promise.resolve(true);
                }
                //label didn't change resolve with false
                return Promise.resolve(false);
            }
        );
    } else {
        logCLPLabelChange(clpViewState.selectedCLPLabel, label);
        const operation = clpViewState.selectedCLPLabel
            ? CLPAuditOperation.LabelUpdated
            : CLPAuditOperation.LabelApplied;
        //Add audit action for upgrading
        addAuditActionToViewState(
            clpViewState,
            constructCLPAuditAction(
                label,
                CLPAuditLogType.LabelAction,
                operation,
                CLPAuditOperationTrigger.Manual,
                CLPAuditSensitivityChange.Upgraded,
                clpViewState.selectedCLPLabel
            )
        );
        setSelectedCLPLabel(label, infoBarViewState, clpViewState);
        //label changed resolve with true
        return Promise.resolve(true);
    }
}
